<div class="printing" *ngIf="display || IsPrinting" [ngClass]="{ 'visible': display, 'printing--thermal': IsThermalLayout, 'printing--a5': IsA5Layout }">
    <ng-container *ngIf="IsThermalLayout">
        <ng-container *ngTemplateOutlet="thermalTicketTpl"></ng-container>
    </ng-container>
    <ng-container *ngIf="IsA5Layout">
        <ng-container *ngTemplateOutlet="a5TicketTpl"></ng-container>
    </ng-container>
</div>

<ng-template #thermalTicketTpl>
    <ng-container *ngIf="Info as ticket">
    <div class="print-view print-view--thermal">
        <!-- PLACE LOGO -->
        <div *ngIf="ticket.logo" class="logo-box">
            <img src="{{ticket.logo}}" alt="Logo" class="logo">
        </div>

        <!-- PLACE AND TABLE -->
        <table style="padding-bottom:15px;">
            <tr style="border-bottom: 1px solid black;">
                <td colspan="6" class="bold left">{{ticket.place}}</td>
                <td colspan="6" *ngIf="ticket.table !== null" class="bold right">{{tr('@place_print_ticket_table')}}: {{ticket.table}}</td>
                <td colspan="6" *ngIf="ticket.table === null" class="bold right">{{tr('@place_print_ticket_barticket')}}</td>
            </tr>
            <ng-container *ngIf="ticket.invoice === null">
                <tr *ngIf="ticket.created_series || ticket.created_invceno" style="font-weight: normal; font-size: 90%">
                    <td colspan="6" class="left">{{ticket.created_series}}</td>
                    <td colspan="6" class="right">{{ticket.created_invceno}}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="ticket.invoice !== null">
                <tr *ngIf="ticket.invoice_series || ticket.invoice_invceno" style="font-weight: normal; font-size: 90%">
                    <td colspan="6" class="left">{{ticket.invoice_series}}</td>
                    <td colspan="6" class="right">{{ticket.invoice_invceno}}</td>
                </tr>
            </ng-container>
        </table>

        <!-- VERIFACTU QRCODE -->
        <div *ngIf="ticket.verifactu_qr_value && !ticket.draft" class="qrcode-box verifactu">
            <div class="qrcode-info">
                QR tributario:
            </div>
            <div class="qrcode-code">
                <img *ngIf="VftQR" [src]="VftQR" [alt]="ticket.verifactu_qr_value || ''">
            </div>
            <div class="qrcode-info">
                VERI*FACTU
            </div>
        </div>

        <!-- BUSINESS INFORMATION -->
        <table style="font-size: 90%; text-align: center;">
            <tr *ngIf="ticket.invoice === null">
                <td colspan="12">
                    <span *ngIf="ticket.business" style="font-weight: bolder;">{{ticket.business}}</span>
                    <span *ngIf="ticket.phone"><br/>{{tr('@place_print_ticket_phone')}}: {{ticket.phone}}</span>
                    <span *ngIf="ticket.taxid"><br/>{{tr('@place_print_ticket_taxid')}}: {{ticket.taxid}}</span>
                    <span *ngIf="ticket.address"><br/>{{ticket.address}}</span>
                </td>
            </tr>
            <tr *ngIf="ticket.invoice !== null">
                <td colspan="12">
                    <span *ngIf="ticket.phone">{{tr('@place_print_ticket_phone')}}: {{ticket.phone}}</span>
                    <span *ngIf="ticket.address"><br/>{{ticket.address}}</span>
                </td>
            </tr>
        </table>

        <!-- INVOICE INFORMATION -->
        <ng-container *ngIf="ticket.invoice">
            <table style="font-size: 90%; text-align: center;">
                <tr style="background: lightgray; height:35px">
                    <td colspan="12" style="text-transform: uppercase;">
                        <b>{{tr('@place_print_ticket_invoice')}}</b>
                    </td>
                </tr>
            </table>
            <table *ngIf="ticket.created_series || ticket.created_invceno" style="font-size: 90%; text-align: left;">
                <tr>
                    <td colspan="3" style="text-align: left;">{{tr('@place_print_ticket_ticket_id')}}</td>
                    <td colspan="9" style="text-align: right;">{{ticket.created_series}}{{ticket.created_invceno}}</td>
                </tr>
                <tr>
                    <td colspan="3" style="text-align: left;">{{tr('@place_print_ticket_ticket_date')}}</td>
                    <td colspan="9" style="text-align: right;">{{ticket.created_date}}</td>
                </tr>
            </table>
            <table *ngIf="ticket.invoice_series || ticket.invoice_invceno" style="font-size: 90%; text-align: left;">
                <tr>
                    <td colspan="3" style="text-align: left;">{{tr('@place_print_ticket_invoice_id')}}</td>
                    <td colspan="9" style="text-align: right;">{{ticket.invoice_series}}{{ticket.invoice_invceno}}</td>
                </tr>
                <tr>
                    <td colspan="3" style="text-align: left;">{{tr('@place_print_ticket_invoice_date')}}</td>
                    <td colspan="9" style="text-align: right;">{{ticket.invoice_date}}</td>
                </tr>
            </table>

            <table style="font-size: 90%; text-align: center;">
                <tr style="background: lightgray; height:35px">
                    <td colspan="12" style="text-transform: uppercase;">
                        <b>{{tr('@place_print_ticket_client')}}</b>
                    </td>
                </tr>
            </table>
            <table style="font-size: 90%; text-align: center;">
                <tr>
                    <td colspan="12">{{ticket.invoice.business}}</td>
                </tr>
                <tr>
                    <td colspan="12">{{tr('@place_print_ticket_taxid')}}: {{ticket.invoice.taxid}}</td>
                </tr>
                <tr *ngIf="ticket.invoice.address">
                    <td colspan="12">
                        {{ticket.invoice.address.trim()}}
                        <span *ngIf="ticket.invoice.postalcode">, {{ticket.invoice.postalcode}}</span>
                        <span *ngIf="ticket.invoice.region">, {{ticket.invoice.region}}</span>
                    </td>
                </tr>
            </table>
            <table style="font-size: 90%; text-align: center;">
                <tr style="background: lightgray; height:35px">
                    <td colspan="12" style="text-transform: uppercase;">
                        <b>{{tr('@place_print_ticket_issuer')}}</b>
                    </td>
                </tr>
            </table>
            <table style="font-size: 90%; text-align: center;">
                <tr>
                    <td colspan="12">
                        <span *ngIf="ticket.business" style="font-weight: bolder;">{{ticket.business}}</span>
                        <span *ngIf="ticket.taxid"><br/>{{tr('@place_print_ticket_taxid')}}: {{ticket.taxid}}</span>
                        <span *ngIf="ticket.fiscal"><br/>{{ticket.fiscal}}</span>
                    </td>
                </tr>
            </table>
        </ng-container>

        <!-- TICKET INFORMATION -->
        <table style="background: lightgray;">
            <tr style="vertical-align: bottom; height:24px; margin-bottom: 0px;">
                <td colspan="8" class="left">
                    <span *ngIf="ticket.invoice === null" class="padding" style="text-transform: uppercase;">
                        {{tr('@place_print_ticket_order')}}
                    </span>
                    <span *ngIf="ticket.invoice !== null" class="padding" style="text-transform: uppercase;">
                        {{tr('@place_print_ticket_invoice')}}
                    </span>
                </td>
                <td colspan="4" class="right padding">
                    {{ticket.order}}
                </td>
            </tr>
            <tr style="vertical-align: top; height: 20px; font-size: 90%; margin-top: 0px; ">
                <td colspan="12" class="right padding">{{ticket.date}} {{ticket.time}}</td>
            </tr>
        </table>
        <table *ngIf="ticket.comments">
            <tr>
                <td class="italic">{{ticket.comments}}</td>
            </tr>
        </table>

        <table style="padding-bottom: 15px; font-size: 90%">
            <!-- PRODUCTS INFORMATION -->
            <ng-container *ngFor="let _item of ticket.products">
                <tr class="item" *ngIf="_item.isweight === true" [ngClass]="{ 'strike': _item.refund || _item.cancel }">
                    <td colspan="8" class="left">
                        <div class="ticket-item">
                            {{_item.count}}{{tr('@kilograms')}}<span style="text-transform: uppercase;"> {{_item.name}}</span>
                        </div>
                    </td>
                    <td colspan="2" class="right">{{_item.price | currency : 'symbol' : ''}}{{tr('@currency')}}/{{tr('@kilograms')}}</td>
                    <td colspan="2" class="right">{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr class="item" *ngIf="_item.isweight !== true" [ngClass]="{ 'strike': _item.refund || _item.cancel }">
                    <td colspan="8" class="left">
                        {{_item.count}}<span style="text-transform: uppercase;"> {{_item.name}}</span>
                    </td>
                    <td colspan="2" class="right">{{_item.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td colspan="2" class="right">{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngIf="_item.fixed && !_item.offer">
                    <td colspan="6" class="left">
                        <span *ngIf="_item.house === true">* {{tr('@place_print_ticket_house')}}</span>
                        <span *ngIf="_item.house !== true">* {{tr('@place_print_ticket_fixed')}}</span>
                    </td>
                    <td colspan="6" class="right">
                        <span *ngIf="_item.adjust < 0">- {{(_item.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                        <span *ngIf="_item.adjust >= 0">+ {{_item.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                    </td>
                </tr>
                <tr *ngIf="_item.offer" [ngClass]="{ 'strike': _item.refund || _item.cancel }">
                    <td colspan="6" class="left">* {{tr('@place_print_ticket_offer')}}</td>
                    <td colspan="6" class="right">-{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _option of _item.options" style="font-size: 90%;">
                    <td colspan="8" class="left" style="padding-left: 8px;">- {{_option.name}}</td>
                    <td colspan="2" class="right">{{_option.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td colspan="2" class="right" *ngIf="_option.total > 0">{{_option.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>

            <!-- MENUS INFORMATION -->
            <ng-container *ngFor="let _menu of ticket.menus">
                <tr>
                    <td colspan="8" class="left">
                        <div class="ticket-item" style="text-transform: uppercase;">{{_menu.count}} {{_menu.name}}</div>
                    </td>
                    <td colspan="2" class="right">{{_menu.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td colspan="2" class="right">{{_menu.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _product of _menu.products">
                    <td colspan="12" class="left"> - {{_product.size}} x <span style="text-transform: uppercase;">{{_product.product.name}}</span></td>
                </tr>
                <tr *ngIf="_menu.fixed">
                    <td colspan="8" class="left">
                        <span *ngIf="_menu.house === true">* {{tr('@place_print_ticket_house')}}</span>
                        <span *ngIf="_menu.house !== true">* {{tr('@place_print_ticket_fixed')}}</span>
                    </td>
                    <td colspan="4" class="right">
                        <span *ngIf="_menu.adjust < 0">- {{(_menu.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                        <span *ngIf="_menu.adjust >= 0">+ {{_menu.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                    </td>
                </tr>
            </ng-container>

            <!-- EXTRAS INFORMATION -->
            <ng-container *ngIf="ticket.extras.length > 0">
                <tr style="height:10px;"><td colspan="12"></td></tr>
                <tr style="height: 35px; background: lightgray;">
                    <td colspan="12" style="text-align: center;">
                        <span class="padding" style="display: block; text-transform: uppercase;">{{tr('@place_print_ticket_extras')}}</span>
                    </td>
                </tr>
                <tr style="height:10px;"><td colspan="12"></td></tr>
            </ng-container>
            <ng-container *ngFor="let _extra of ticket.extras">
                <tr>
                    <td colspan="8" style="text-transform: uppercase;" class="left">{{_extra.name}}</td>
                    <td colspan="4" class="right">{{_extra.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>

            <!-- OFFERS INFORMATION -->
            <ng-container *ngIf="ticket.offers.length > 0">
                <tr style="height:10px;"><td colspan="12"></td></tr>
                <tr style="height: 35px; background: lightgray;">
                    <td colspan="12" style="text-align: center;">
                        <span class="padding" style="display: block; text-transform: uppercase;">{{tr('@place_print_ticket_offers')}}</span>
                    </td>
                </tr>
                <tr style="height:10px;"><td colspan="12"></td></tr>
            </ng-container>
            <ng-container *ngFor="let _offer of ticket.offers">
                <tr>
                    <td colspan="8" class="left">
                        <div class="ticket-item" style="text-transform: uppercase;">{{_offer.count}} {{_offer.name}}</div>
                    </td>
                    <td colspan="2" class="right">{{_offer.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td colspan="2" class="right">{{_offer.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _product of _offer.products">
                    <td colspan="12" class="left"> - {{_product.size}} x <span style="text-transform: uppercase;">{{_product.product.name}}</span></td>
                </tr>
                <tr *ngIf="_offer.fixed">
                    <td colspan="8" class="left">
                        <span *ngIf="_offer.house === true">* {{tr('@place_print_ticket_house')}}</span>
                        <span *ngIf="_offer.house !== true">* {{tr('@place_print_ticket_fixed')}}</span>
                    </td>
                    <td colspan="4" class="right">
                        <span *ngIf="_offer.adjust < 0">- {{(_offer.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                        <span *ngIf="_offer.adjust >= 0">+ {{_offer.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span>
                    </td>
                </tr>
            </ng-container>

            <!-- DISCOUNTS INFORMATION -->
            <ng-container *ngIf="ticket.discounts.length > 0">
                <tr style="height:10px;"><td colspan="12"></td></tr>
                <tr style="height: 35px; background: lightgray;">
                    <td colspan="12" style="text-align: center;">
                        <span class="padding" style="display: block; text-transform: uppercase;">{{tr('@place_print_ticket_discounts')}}</span>
                    </td>
                </tr>
                <tr style="height:10px;"><td colspan="12"></td></tr>
            </ng-container>
            <ng-container *ngFor="let _discount of ticket.discounts">
                <tr>
                    <td colspan="8" class="left">
                        <div class="ticket-item" style="text-transform: uppercase;">
                            {{_discount.name}}<span *ngIf="_discount.percent !== null"> ({{_discount.percent}}%)</span>
                        </div>
                    </td>
                    <td colspan="4" class="right">- {{_discount.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>
        </table>

        <!-- PAYMENT INFORMATION -->
        <div style="width: 100%;">
            <table *ngIf="(ticket.showpay && ticket.payment) || ticket.draft || ticket.cancelled" style="border: 1px solid black;">
                <tr *ngIf="ticket.showpay && ticket.payment">
                    <td *ngIf="ticket.payment === 'PAYCASH'" style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_paycash')}}</td>
                    <td *ngIf="ticket.payment === 'PAYCARD'" style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_paycard')}}</td>
                    <td *ngIf="ticket.payment === 'PAYMIXED'" style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_paymixed')}}</td>
                    <td *ngIf="ticket.payment === 'PAYLINE'" style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_payline')}}</td>
                </tr>
                <tr *ngIf="ticket.draft">
                    <td style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_draft')}}</td>
                </tr>
                <tr *ngIf="ticket.cancelled">
                    <td style="text-transform: uppercase; text-align: center; padding-top: 2px; padding-bottom: 2px;">{{tr('@place_print_ticket_cancelled')}}</td>
                </tr>
            </table>
        </div>

        <table *ngIf="ticket.showpay && (ticket.payment === 'PAYMIXED')">
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_mixed_cash')}}</td>
                <td colspan="4" class="right">{{ticket.cash | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_mixed_card')}}</td>
                <td colspan="4" class="right">{{ticket.card | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
        </table>

        <table *ngIf="(ticket.diners !== null)" style="margin-bottom: 5px;">
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_diners')}}</td>
                <td colspan="4" class="right">{{ticket.diners}}</td>
            </tr>
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_price_per_diner')}}</td>
                <td colspan="4" class="right">{{(ticket.total / ticket.diners) | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
        </table>
        <table>
            <tr>
                <td colspan="8" class="left padding" style="text-transform: uppercase;">{{tr('@place_print_ticket_base')}}</td>
                <td colspan="4" class="right padding" style="text-transform: uppercase;">{{ticket.base | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
            <ng-container *ngIf="ticket.rates.length > 1">
                <tr *ngFor="let taxrate of ticket.rates" style="font-size: 90% !important;">
                    <td colspan="8" class="left padding" style="text-transform: uppercase; padding-left: 10px;">{{taxrate.base | currency : 'symbol' : ''}}{{tr('@currency')}} {{tr('@place_print_ticket_tax', [taxrate.rate])}}</td>
                    <td colspan="4" class="right padding" style="text-transform: uppercase;">{{taxrate.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr>
                    <td colspan="8" class="left padding" style="text-transform: uppercase;">{{tr('@place_print_ticket_tax_total')}}</td>
                    <td colspan="4" class="right padding" style="text-transform: uppercase;">{{ticket.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="ticket.rates.length === 1">
                <tr *ngFor="let taxrate of ticket.rates">
                    <td colspan="8" class="left padding" style="text-transform: uppercase;">{{tr('@place_print_ticket_tax', [taxrate.rate])}}</td>
                    <td colspan="4" class="right padding" style="text-transform: uppercase;">{{taxrate.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>
        </table>
        <table style="padding-bottom: 15px;">
            <tr style="background: black; color: white; font-size: 120%; font-weight: bolder; height: 35px;">
                <td colspan="8" class="left padding" style="text-transform: uppercase;">{{tr('@place_print_ticket_total')}}</td>
                <td colspan="4" class="right padding" style="text-transform: uppercase;">{{ticket.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
        </table>

        <table *ngIf="(ticket.payment === 'PAYCASH') && (ticket.given !== null)">
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_given')}}</td>
                <td colspan="4" class="right">{{ticket.given | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
            <tr>
                <td colspan="8" class="left" style="text-transform: uppercase;">{{tr('@place_print_ticket_return')}}</td>
                <td colspan="4" class="right">{{ticket.return | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
        </table>

        <!-- GREETING MESSAGE -->
        <table style="margin-top: 15px; border-top: 1px solid black; padding-top:15px;">
            <tr>
                <td class="center" style="height:40px; text-transform: uppercase;">- {{tr('@place_print_ticket_thanks')}} -</td>
            </tr>
        </table>

        <!-- TICKETBAI QRCODE -->
        <div *ngIf="ticket.ticketbai_qr_value && !ticket.draft" class="qrcode-box ticketbai">
            <div class="qrcode-info">
                {{ticket.ticketbai_info}}
            </div>
            <div class="qrcode-code">
                <img *ngIf="BaiQR" [src]="BaiQR" [alt]="ticket.ticketbai_qr_value || ''">
            </div>
        </div>

        <div style="clear: both; height: 60px;"></div>
    </div>
    </ng-container>
</ng-template>

<ng-template #a5TicketTpl>
    <ng-container *ngIf="Info as ticket">
    <div class="print-view print-view--a5" style="box-sizing: border-box; width: 100%; max-width: 148mm; min-height: 210mm; margin: 0 auto; padding: 10mm 11mm 12mm; font-family: Helvetica, Arial, sans-serif; font-size: 11px; line-height: 1.35; color: #000; background: #fff;">
        <table style="width: 100%; margin-top: 0;">
            <tr style="vertical-align: top;">
                <td style="width: 70%; padding: 0;">
                    <table style="width: 100%; margin-top: 0;">
                        <tr style="vertical-align: top;">
                            <td *ngIf="ticket.logo" style="width: 42%; text-align: left; padding-right: 4mm;">
                                <img src="{{ticket.logo}}" alt="Logo" style="display: block; max-height: 22mm; max-width: 100%;">
                            </td>
                            <td style="text-align: right;">
                                <div style="font-size: 12px; font-weight: bold; margin-bottom: 1mm;">{{ticket.place}}</div>
                                <ng-container *ngIf="ticket.invoice === null">
                                    <div *ngIf="ticket.business" style="font-size: 10px; font-weight: bold;">{{ticket.business}}</div>
                                    <div *ngIf="ticket.phone" style="font-size: 10px;">{{tr('@place_print_ticket_phone')}}: {{ticket.phone}}</div>
                                    <div *ngIf="ticket.taxid" style="font-size: 10px;">{{tr('@place_print_ticket_taxid')}}: {{ticket.taxid}}</div>
                                    <div *ngIf="ticket.address_line1 || ticket.address" style="font-size: 10px;">{{ticket.address_line1 || ticket.address}}</div>
                                    <div *ngIf="ticket.address_line2" style="font-size: 10px;">{{ticket.address_line2}}</div>
                                </ng-container>
                                <ng-container *ngIf="ticket.invoice !== null">
                                    <div *ngIf="ticket.phone" style="font-size: 10px;">{{tr('@place_print_ticket_phone')}}: {{ticket.phone}}</div>
                                    <div *ngIf="ticket.address_line1 || ticket.address" style="font-size: 10px;">{{ticket.address_line1 || ticket.address}}</div>
                                    <div *ngIf="ticket.address_line2" style="font-size: 10px;">{{ticket.address_line2}}</div>
                                </ng-container>
                            </td>
                        </tr>
                    </table>
                    <table *ngIf="ticket.invoice === null" style="width: 100%; margin-top: 2mm; border-top: 1px solid #ccc;">
                        <tr>
                            <td style="font-size: 10px; font-weight: bold; text-align: left; padding-top: 2mm;">
                                <ng-container *ngIf="ticket.table !== null">{{tr('@place_print_ticket_table')}}: {{ticket.table}}</ng-container>
                                <ng-container *ngIf="ticket.table === null">{{tr('@place_print_ticket_barticket')}}</ng-container>
                            </td>
                            <td *ngIf="ticket.created_series || ticket.created_invceno" style="font-size: 10px; font-weight: bold; text-align: right; padding-top: 2mm;">{{ticket.created_series}}{{ticket.created_invceno}}</td>
                        </tr>
                    </table>
                </td>
                <td *ngIf="ticket.verifactu_qr_value && !ticket.draft" style="width: 30%; text-align: center; padding-left: 6mm;">
                    <div style="font-size: 10px;">{{tr('@place_print_ticket_verifactu_qr_label')}}</div>
                    <div style="display: block; margin: 2mm auto; width: 32mm; height: 32mm; box-sizing: content-box; padding: 2mm; border: 1px solid #000; background: #fff;">
                        <img *ngIf="VftQR" [src]="VftQR" [alt]="ticket.verifactu_qr_value || ''" style="display: block; width: 32mm; height: 32mm; margin: 0 auto;">
                    </div>
                    <div style="font-size: 10px;">VERI*FACTU</div>
                </td>
            </tr>
        </table>

        <ng-container *ngIf="ticket.invoice">
            <table style="width: 100%; margin-top: 3mm;">
                <tr>
                    <td style="background: #e8e8e8; padding: 2mm; text-transform: uppercase; font-size: 10px;"><b>{{tr('@place_print_ticket_invoice')}}</b></td>
                </tr>
            </table>
            <table style="width: 100%; margin-top: 1mm; font-size: 10px;">
                <tr>
                    <td style="width: 50%; padding-right: 2.5mm;">
                        <span style="font-weight: bold;">{{tr('@place_print_ticket_ticket_id')}}:</span>
                        <span style="float: right;">{{ticket.created_series}}{{ticket.created_invceno}}</span>
                    </td>
                    <td style="width: 50%; padding-left: 2.5mm;">
                        <span style="font-weight: bold;">{{tr('@place_print_ticket_ticket_date')}}:</span>
                        <span style="float: right;">{{ticket.created_date || '-'}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="width: 50%; padding-right: 2.5mm;">
                        <span style="font-weight: bold;">{{tr('@place_print_ticket_invoice_id')}}:</span>
                        <span style="float: right;">{{ticket.invoice_series}}{{ticket.invoice_invceno}}</span>
                    </td>
                    <td style="width: 50%; padding-left: 2.5mm;">
                        <span style="font-weight: bold;">{{tr('@place_print_ticket_invoice_date')}}:</span>
                        <span style="float: right;">{{ticket.invoice_date || '-'}}</span>
                    </td>
                </tr>
            </table>

            <table style="width: 100%; margin-top: 2mm;">
                <tr style="vertical-align: top;">
                    <td style="width: 50%; padding-right: 2.5mm; text-align: left;">
                        <table style="width: 100%; margin-top: 0;">
                            <tr>
                                <td style="background: #e8e8e8; padding: 2mm; text-transform: uppercase; font-size: 10px;"><b>{{tr('@place_print_ticket_issuer')}}</b></td>
                            </tr>
                        </table>
                        <table style="width: 100%; margin-top: 1mm; font-size: 10px;">
                            <tr><td style="text-align: left;">
                                <span *ngIf="ticket.business" style="font-weight: bold;">{{ticket.business}}</span>
                                <span *ngIf="ticket.taxid"><br/>{{tr('@place_print_ticket_taxid')}}: {{ticket.taxid}}</span>
                                <span *ngIf="ticket.fiscal_line1 || ticket.fiscal"><br/>{{ticket.fiscal_line1 || ticket.fiscal}}</span>
                                <span *ngIf="ticket.fiscal_line2"><br/>{{ticket.fiscal_line2}}</span>
                            </td></tr>
                        </table>
                    </td>
                    <td style="width: 50%; padding-left: 2.5mm; text-align: right;">
                        <table style="width: 100%; margin-top: 0;">
                            <tr>
                                <td style="background: #e8e8e8; padding: 2mm; text-transform: uppercase; font-size: 10px; text-align: right;"><b>{{tr('@place_print_ticket_client')}}</b></td>
                            </tr>
                        </table>
                        <table style="width: 100%; margin-top: 1mm; font-size: 10px;">
                            <tr><td style="text-align: right;">
                                <span style="font-weight: bold;">{{ticket.invoice.business}}</span>
                                <span><br/>{{tr('@place_print_ticket_taxid')}}: {{ticket.invoice.taxid}}</span>
                                <span *ngIf="ticket.invoice.address_line1 || ticket.invoice.address"><br/>{{ticket.invoice.address_line1 || ticket.invoice.address}}</span>
                                <span *ngIf="ticket.invoice.address_line2"><br/>{{ticket.invoice.address_line2}}</span>
                            </td></tr>
                        </table>
                    </td>
                </tr>
            </table>
        </ng-container>

        <table style="width: 100%; margin-top: 2mm; background: #e8e8e8; font-size: 10px;">
            <tr>
                <td style="text-align: left; padding: 1mm 2mm;">
                    <span *ngIf="ticket.invoice === null">{{tr('@place_print_ticket_order')}}</span>
                    <span *ngIf="ticket.invoice !== null">{{tr('@place_print_ticket_invoice')}}</span>
                </td>
                <td style="text-align: right; white-space: nowrap; padding: 1mm 2mm;">{{ticket.order}}</td>
            </tr>
            <tr>
                <td colspan="2" style="text-align: right; font-size: 9px; padding: 0.5mm 2mm 0.8mm;">{{ticket.date}} {{ticket.time}}</td>
            </tr>
        </table>
        <table *ngIf="ticket.comments" style="width: 100%; margin-top: 1mm; font-size: 10px;"><tr><td style="font-style: italic;">{{ticket.comments}}</td></tr></table>

        <table style="width: 100%; margin-top: 2mm; font-size: 10px; border-collapse: collapse;">
            <ng-container *ngFor="let _item of ticket.products">
                <tr *ngIf="_item.isweight === true" [style.text-decoration]="_item.refund || _item.cancel ? 'line-through' : null">
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.count}}{{tr('@kilograms')}} {{_item.name | uppercase}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.price | currency : 'symbol' : ''}}{{tr('@currency')}}/{{tr('@kilograms')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngIf="_item.isweight !== true" [style.text-decoration]="_item.refund || _item.cancel ? 'line-through' : null">
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.count}} {{_item.name | uppercase}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngIf="_item.fixed && !_item.offer">
                    <td colspan="2" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_item.house === true">* {{tr('@place_print_ticket_house')}}</span><span *ngIf="_item.house !== true">* {{tr('@place_print_ticket_fixed')}}</span></td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_item.adjust < 0">- {{(_item.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span><span *ngIf="_item.adjust >= 0">+ {{_item.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span></td>
                </tr>
                <tr *ngIf="_item.offer" [style.text-decoration]="_item.refund || _item.cancel ? 'line-through' : null">
                    <td colspan="2" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">* {{tr('@place_print_ticket_offer')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">-{{_item.charge | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _option of _item.options" style="font-size: 9px;">
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">- {{_option.name}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_option.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_option.total > 0">{{_option.total | currency : 'symbol' : ''}}{{tr('@currency')}}</span></td>
                </tr>
            </ng-container>
            <ng-container *ngFor="let _menu of ticket.menus">
                <tr>
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_menu.count}} {{_menu.name | uppercase}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_menu.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_menu.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _product of _menu.products" style="font-size: 9px;"><td colspan="3" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">- {{_product.size}} x {{_product.product.name | uppercase}}</td></tr>
                <tr *ngIf="_menu.fixed">
                    <td colspan="2" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_menu.house === true">* {{tr('@place_print_ticket_house')}}</span><span *ngIf="_menu.house !== true">* {{tr('@place_print_ticket_fixed')}}</span></td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_menu.adjust < 0">- {{(_menu.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span><span *ngIf="_menu.adjust >= 0">+ {{_menu.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span></td>
                </tr>
            </ng-container>
            <ng-container *ngIf="ticket.extras.length > 0">
                <tr><td colspan="3" style="background: #f0f0f0; font-weight: bold; text-transform: uppercase; border-top: 2px solid #fff; padding: 1.2mm 1mm;">{{tr('@place_print_ticket_extras')}}</td></tr>
            </ng-container>
            <ng-container *ngFor="let _extra of ticket.extras">
                <tr><td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_extra.name | uppercase}}</td><td colspan="2" style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_extra.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            </ng-container>
            <ng-container *ngIf="ticket.offers.length > 0">
                <tr><td colspan="3" style="background: #f0f0f0; font-weight: bold; text-transform: uppercase; border-top: 2px solid #fff; padding: 1.2mm 1mm;">{{tr('@place_print_ticket_offers')}}</td></tr>
            </ng-container>
            <ng-container *ngFor="let _offer of ticket.offers">
                <tr>
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_offer.count}} {{_offer.name | uppercase}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_offer.price | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_offer.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
                <tr *ngFor="let _product of _offer.products" style="font-size: 9px;"><td colspan="3" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">- {{_product.size}} x {{_product.product.name | uppercase}}</td></tr>
                <tr *ngIf="_offer.fixed">
                    <td colspan="2" style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_offer.house === true">* {{tr('@place_print_ticket_house')}}</span><span *ngIf="_offer.house !== true">* {{tr('@place_print_ticket_fixed')}}</span></td>
                    <td style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;"><span *ngIf="_offer.adjust < 0">- {{(_offer.adjust * -1) | currency : 'symbol' : ''}}{{tr('@currency')}}</span><span *ngIf="_offer.adjust >= 0">+ {{_offer.adjust | currency : 'symbol' : ''}}{{tr('@currency')}}</span></td>
                </tr>
            </ng-container>
            <ng-container *ngIf="ticket.discounts.length > 0">
                <tr><td colspan="3" style="background: #f0f0f0; font-weight: bold; text-transform: uppercase; border-top: 2px solid #fff; padding: 1.2mm 1mm;">{{tr('@place_print_ticket_discounts')}}</td></tr>
            </ng-container>
            <ng-container *ngFor="let _discount of ticket.discounts">
                <tr>
                    <td style="text-align: left; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">{{_discount.name | uppercase}}<span *ngIf="_discount.percent !== null"> ({{_discount.percent}}%)</span></td>
                    <td colspan="2" style="text-align: right; white-space: nowrap; border-bottom: 1px solid #ccc; padding: 1.2mm 1mm;">- {{_discount.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
                </tr>
            </ng-container>
        </table>

        <table *ngIf="(ticket.showpay && ticket.payment) || ticket.draft || ticket.cancelled" style="width: 100%; margin-top: 3mm; border: 1px solid #000; font-size: 10px; text-transform: uppercase;">
            <tr *ngIf="ticket.showpay && ticket.payment">
                <td *ngIf="ticket.payment === 'PAYCASH'" style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_paycash')}}</td>
                <td *ngIf="ticket.payment === 'PAYCARD'" style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_paycard')}}</td>
                <td *ngIf="ticket.payment === 'PAYMIXED'" style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_paymixed')}}</td>
                <td *ngIf="ticket.payment === 'PAYLINE'" style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_payline')}}</td>
            </tr>
            <tr *ngIf="ticket.draft"><td style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_draft')}}</td></tr>
            <tr *ngIf="ticket.cancelled"><td style="text-align: center; padding: 2mm;">{{tr('@place_print_ticket_cancelled')}}</td></tr>
        </table>
        <table *ngIf="ticket.showpay && (ticket.payment === 'PAYMIXED')" style="width: 100%; margin-top: 1mm; font-size: 10px;">
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_mixed_cash')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.cash | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_mixed_card')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.card | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
        </table>
        <table *ngIf="(ticket.diners !== null)" style="width: 100%; margin-top: 1mm; font-size: 10px;">
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_diners')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.diners}}</td></tr>
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_price_per_diner')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{(ticket.total / ticket.diners) | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
        </table>
        <table style="width: 100%; margin-top: 3mm; font-size: 10px;">
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_base')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.base | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            <ng-container *ngIf="ticket.rates.length > 1">
                <tr *ngFor="let taxrate of ticket.rates"><td style="padding: 1mm 0 1mm 3mm;">{{taxrate.base | currency : 'symbol' : ''}}{{tr('@currency')}} {{tr('@place_print_ticket_tax', [taxrate.rate])}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{taxrate.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
                <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_tax_total')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            </ng-container>
            <ng-container *ngIf="ticket.rates.length === 1">
                <tr *ngFor="let taxrate of ticket.rates"><td style="padding: 1mm 0;">{{tr('@place_print_ticket_tax', [taxrate.rate])}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{taxrate.taxes | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            </ng-container>
            <tr>
                <td style="padding-top: 2mm; border-top: 2px solid #000; font-size: 12px; font-weight: bold;">{{tr('@place_print_ticket_total')}}</td>
                <td style="text-align: right; white-space: nowrap; padding-top: 2mm; border-top: 2px solid #000; font-size: 12px; font-weight: bold;">{{ticket.total | currency : 'symbol' : ''}}{{tr('@currency')}}</td>
            </tr>
        </table>
        <table *ngIf="(ticket.payment === 'PAYCASH') && (ticket.given !== null)" style="width: 100%; margin-top: 1mm; font-size: 10px;">
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_given')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.given | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
            <tr><td style="padding: 1mm 0;">{{tr('@place_print_ticket_return')}}</td><td style="text-align: right; white-space: nowrap; padding: 1mm 0;">{{ticket.return | currency : 'symbol' : ''}}{{tr('@currency')}}</td></tr>
        </table>

        <table style="width: 100%; margin-top: 5mm; border-top: 1px solid #000;">
            <tr><td style="text-align: center; text-transform: uppercase; font-size: 10px; padding-top: 3mm;">- {{tr('@place_print_ticket_thanks')}} -</td></tr>
        </table>

        <table *ngIf="ticket.ticketbai_qr_value && !ticket.draft" style="width: 100%; margin-top: 4mm;">
            <tr><td style="text-align: center; font-size: 10px;">{{ticket.ticketbai_info}}</td></tr>
            <tr>
                <td style="text-align: center;">
                    <div style="display: inline-block; width: 32mm; height: 32mm; box-sizing: content-box; padding: 2mm; border: 1px solid #000; background: #fff;">
                        <img *ngIf="BaiQR" [src]="BaiQR" [alt]="ticket.ticketbai_qr_value || ''" style="display: block; width: 32mm; height: 32mm;">
                    </div>
                </td>
            </tr>
        </table>
        <div style="height: 8mm;"></div>
    </div>
    </ng-container>
</ng-template>
